import { render, staticRenderFns } from "./OrderShippingNotificationConfig.vue?vue&type=template&id=5eaae7e3&scoped=true&"
import script from "./OrderShippingNotificationConfig.vue?vue&type=script&lang=js&"
export * from "./OrderShippingNotificationConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaae7e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eaae7e3')) {
      api.createRecord('5eaae7e3', component.options)
    } else {
      api.reload('5eaae7e3', component.options)
    }
    module.hot.accept("./OrderShippingNotificationConfig.vue?vue&type=template&id=5eaae7e3&scoped=true&", function () {
      api.rerender('5eaae7e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/OrderShippingNotification/OrderShippingNotificationConfig.vue"
export default component.exports